import { Card, CardContent } from '@/components/ui/card'
import {
  Wallet,
  TrendingUp,
  CreditCard,
  Smartphone,
  Banknote,
  Lock,
} from 'lucide-react'
import { useI18n } from '@/store/I18nContext'

export function IntelligentPayments() {
  const { t } = useI18n()

  return (
    <section className="py-20 font-sans" id="pagamentos">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter mb-4 leading-tight">
            {t('pay.title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-medium">
            {t('pay.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto animate-fade-in">
          {/* Previsibilidade de Pagamentos */}
          <Card className="border bg-card shadow-sm hover:shadow-md hover:border-primary/50 transition-all group">
            <CardContent className="p-6 md:p-8 space-y-4 h-full flex flex-col">
              <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <TrendingUp className="h-6 w-6" />
              </div>
              <h3 className="font-bold tracking-tight text-xl">
                {t('pay.predictTitle')}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed font-medium flex-1">
                {t('pay.predictDesc')}
              </p>
            </CardContent>
          </Card>

          {/* Múltiplos Métodos */}
          <Card className="border bg-card shadow-sm hover:shadow-md hover:border-primary/50 transition-all group">
            <CardContent className="p-6 md:p-8 space-y-4 h-full flex flex-col">
              <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <Wallet className="h-6 w-6" />
              </div>
              <h3 className="font-bold tracking-tight text-xl">
                {t('pay.methodsTitle')}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed font-medium">
                {t('pay.methodsDesc')}
              </p>
              <div className="flex flex-col gap-3 mt-auto pt-4">
                <div className="flex items-center gap-3 text-sm font-bold bg-muted/50 p-2 rounded-md">
                  <CreditCard className="h-5 w-5 text-blue-600" />{' '}
                  {t('pay.card')}
                </div>
                <div className="flex items-center gap-3 text-sm font-bold bg-muted/50 p-2 rounded-md">
                  <Smartphone className="h-5 w-5 text-teal-600" />{' '}
                  {t('pay.pix')}
                </div>
                <div className="flex items-center gap-3 text-sm font-bold bg-muted/50 p-2 rounded-md">
                  <Banknote className="h-5 w-5 text-emerald-600" />{' '}
                  {t('pay.cash')}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Gestão de Caixa */}
          <Card className="border bg-card shadow-sm hover:shadow-md hover:border-primary/50 transition-all group">
            <CardContent className="p-6 md:p-8 space-y-4 h-full flex flex-col">
              <div className="bg-primary/10 w-12 h-12 rounded-lg flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <Lock className="h-6 w-6" />
              </div>
              <h3 className="font-bold tracking-tight text-xl">
                {t('pay.cashTitle')}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed font-medium flex-1">
                {t('pay.cashDesc')}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}
